import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { CardActions } from '../CardActions/index.esm.js';
import { C as CardAlert } from '../CardAlert.esm.js';
export { a as getCardAlertSvgPathDefault, b as getCardAlertTitleAsDefault, g as getCardAlertVariantDefault } from '../CardAlert.esm.js';
import { CardContent } from '../CardContent/index.esm.js';
import { CardHeader } from '../CardHeader/index.esm.js';
import 'react-i18next';
import '@skatteetaten/ds-buttons';
import '@skatteetaten/ds-icons';
import '@skatteetaten/ds-typography';
import './styles.css';


const getCardColorDefault = ()=>'white';

var styles = {
    "card": "Card-module_card__ZL3Ek"
};

const Card = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, color = getCardColorDefault(), ariaLabelledBy, spacing, children }, ref)=>{
    const cardClassName = `${styles.card} ${className}`.trim();
    const Tag = ariaLabelledBy ? 'section' : 'div';
    return /*#__PURE__*/ jsx(Tag, {
        ref: ref,
        id: id,
        className: cardClassName,
        lang: lang,
        "data-testid": dataTestId,
        "data-color": color,
        "aria-labelledby": ariaLabelledBy,
        "data-spacing": spacing,
        children: children
    });
});
Card.displayName = 'Card';
Card.Alert = CardAlert;
Card.Actions = CardActions;
Card.Content = CardContent;
Card.Header = CardHeader;

export { Card, getCardColorDefault };
